var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button",attrs:{"value":_vm.active,"title":_vm.title},on:{"click":_vm.activate}},[_c('img',{attrs:{"src":require('@/assets/toolbar/instruments/'+this.instrument.name+'.png')}})])}
var staticRenderFns = []

export { render, staticRenderFns }